import React from 'react';
import { withRouter } from 'react-router';
import logo from 'media/logo.png';
import styles from './styles';
import Burguer from '../Burguer/index';

const NavElements = ({ open, toggle }) => {

    return (
        <>
            <styles.LogoLink to="/">
                <styles.Logo src={logo} alt="Oracliom" />
            </styles.LogoLink>
            <styles.Nav >
                <Burguer toggle={toggle} open={open} />
                <styles.Menu>
                    <styles.Link to="/landing?section=about"> ABOUT US </styles.Link>
                    <styles.Link to="/landing?section=portfolio"> PORTFOLIO  </styles.Link>
                    <styles.Link to="/landing?section=mlp"> MLP </styles.Link>
                    <styles.Link to="/landing?section=teamassembly"> TEAM ASSEMBLY </styles.Link>
                    <styles.Link to="/shop"> <b>SHOP</b> </styles.Link>
                </styles.Menu>
            </styles.Nav>
        </>

    );
};

export default withRouter(NavElements);
